// Controle de acesso da página "Templates com Erro".
// Regra: visível/abrível somente para o time 159.
//
// ATENÇÃO ao naming traiçoeiro do CRM: o que o backend chama de `id_time`
// é persistido no front, no localStorage, com a chave `id_cliente`.
// Portanto "159" aqui é o id_time, lido via localStorage.getItem("id_cliente").
export const TEMPLATES_ERRO_ID_CLIENTE = "159";

export const canViewTemplatesComErro = (): boolean =>
  localStorage.getItem("id_cliente") === TEMPLATES_ERRO_ID_CLIENTE;
